import { useEffect, useState } from 'react';

import { getPublicSettings } from '../services/SettingsServices';

// { paymentProvider, cloudinary, googleClientId, … } or null while loading
const usePublicSettings = () => {
    const [settings, setSettings] = useState(null);
    useEffect(() => {
        let alive = true;
        getPublicSettings().then(s => alive && setSettings(s));
        return () => { alive = false; };
    }, []);
    return settings;
};

export default usePublicSettings;
